
import React, {Component, Fragment} from 'react'
import { GiRotaryPhone } from "react-icons/gi";
import Rating from '../../../components/rating/rating';
import { Button } from 'reactstrap';

const arraySort = require('array-sort');
var configurationManager = require('../../../utils/config/configurationManager.js');
var translator = require('../../../utils/translator/translator.js');
var stringUtil = require('../../../utils/string/stringUtil');
var commonUtility = require('../../../utils/domain/commonUtility.js');
var stateManager = require('../../../utils/state/stateManager.js');
var logger = require('../../../utils/logger/logger.js');
var guidUtil = require('../../../utils/guid/guidUtil');
var saleContextUtil = require('../../../views/Order/utils/saleContextUtil.js');
var navigationButtonsIds = require('../../../views/Navigation/navigationButtonsIds.js');
var navigationDialogueAction = require('../../../utils/state/actions/views/navigationDialogue/navigationDialogueAction.js');
var userNotificationsUtil = require('../../../utils/userNotifications/userNotificationsUtil');
var staffUtility = require('../../../utils/domain/staff/staffUtility');
var staffAccessUtility = require('../../../utils/domain/staff/staffAccessUtility');
var staffActivities = require('../../../utils/domain/staff/staffActivities');

class NotificationDetail extends Component 
{
    render()
    {
        var cloudName = configurationManager.getConfig().cdnAppCloudName;
        
        return <div style={{border:'1px solid #B0B0B0'}}>
                    <table width="100%">
                        <tr>
                            <td align="center">
                            <div style={{paddingTop:'5px', paddingBottom:'5px', background:'var(--colors-primary)', color:'var(--colors-white)'}}>
                                    <table>
                                        <tr>
                                            <td>
                                                <GiRotaryPhone size={30}/>
                                            </td>
                                            <td>
                                                <div style={{marginLeft:'5px', fontSize:'1.5rem'}}>{translator.getLabel("incoming_call")}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </td>
                        </tr>

                        {this.renderPrivilegesError()}

                        <tr>
                            <td>
                                <div style={{marginTop:'30px'}}>
                                    {this.renderToolbar()}
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <hr style={{marginTop:'30px', marginBottom:'30px'}}/>
                            </td>
                        </tr>
                     
                        <tr>
                            <td>
                                <div style={{marginLeft:'20px', marginRight:'20px'}}>
                                    {this.renderCustomer()}
                                </div>
                            </td>
                        </tr>

                        


                </table>
            </div>
    }

    renderPrivilegesError()
    {
        if (staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder))
            return null;

        return <Fragment>
                        <tr>
                            <td>
                                <div style={{color:'darkred', textAlign:'center', fontSize:'1.2rem', marginTop:'10px'}}>
                                    {translator.getLabel("not_sufficient_privileges_to_place_an_order")}
                                </div>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                <hr style={{margin:'0px', padding:'0px', marginTop:'10px', marginBottom:'10px'}}/>
                            </td>
                        </tr>
                    </Fragment>
    }

    renderToolbar()
    {
        var disabled = false;
        if (staffUtility.getLoginStaff() == null || !staffAccessUtility.canCurrentStaffPerformActivity(staffActivities.canPlaceAnOrder))
            disabled = true;

        let cliDetails = this.props.notification.payload;

        let sale = null;
        if(cliDetails.openOrders != null && cliDetails.openOrders.length > 0)
        {
            const propertyId = commonUtility.getProperty().id;
            let openOrders = cliDetails.openOrders.filter(x => x.propertyId === propertyId);
            arraySort(openOrders, "orderDate", { reverse: true });

            if (openOrders.length > 0)
            {
                sale = stateManager.getStore().getState().todaySales.find(s => stringUtil.areStringSame(s.id, openOrders[0].saleId));
                logger.warn(`Failed to find sale in todays sale as part of incoming call`);
            }
        }

        let components = [];
        if (sale != null)
        {
            components.push(<Button className='btn-action' disabled={disabled} style={{marginRight:'10px', paddingLeft:'10px', paddingRight:'10px'}} onClick={
                                ()=> {
                                        logger.info(`User presses to open existing sale for incoming call: ${cliDetails.cliIncomingNumber} with order number; ${cliDetails.cliIncomingNumber}`);
                                        saleContextUtil.openSale(sale, true);                                            
                                    }}>
                                {translator.getLabel("open_latest_order")} - {sale.number}
                            </Button>)
        }


        components.push(<Button className='btn-action' disabled={disabled} style={{marginRight:'10px'}} onClick={()=>
                            {
                                logger.info(`User presses Collection button for incoming call: ${cliDetails.cliIncomingNumber}`);
                                
                                let navigationDialoguePayload  = {}
                                navigationDialoguePayload.id = navigationButtonsIds.collection;
                                navigationDialoguePayload.existingCustomer = cliDetails.customer;
                                if (navigationDialoguePayload.existingCustomer == null)
                                {
                                    navigationDialoguePayload.existingCustomer = {};
                                    navigationDialoguePayload.existingCustomer.id = guidUtil.generateGuid();
                                    navigationDialoguePayload.existingCustomer.phoneNumber = cliDetails.cliIncomingNumber;
                                }
                                navigationDialoguePayload.component = "customer";
                                stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));

                            }}>
                            {translator.getLabel("collection")}
                        </Button>)

        components.push(<Button className='btn-action' disabled={disabled} style={{marginRight:'10px'}} onClick={()=>
                            {
                                logger.info(`User presses Delivery button for incoming call: ${cliDetails.cliIncomingNumber}`);
                               
                                let navigationDialoguePayload  = {}
                                navigationDialoguePayload.id = navigationButtonsIds.delivery;
                                navigationDialoguePayload.existingCustomer = cliDetails.customer;
                                if (navigationDialoguePayload.existingCustomer == null)
                                {
                                    navigationDialoguePayload.existingCustomer = {};
                                    navigationDialoguePayload.existingCustomer.id = guidUtil.generateGuid();
                                    navigationDialoguePayload.existingCustomer.phoneNumber = cliDetails.cliIncomingNumber;
                                }
                                navigationDialoguePayload.component = "customer";
                                stateManager.getStore().dispatch(navigationDialogueAction.createAction(navigationDialoguePayload));
                            }}>
                            {translator.getLabel("delivery")}
                        </Button>)

        components.push(<Button disabled={disabled} className='btn-cancel'
                            onClick={()=>
                                {
                                    logger.info(`User presses Dismiss button for incoming call: ${cliDetails.cliIncomingNumber}`);
                                    userNotificationsUtil.deleteNotifications(this.props.notification.id)
                                }}>{translator.getLabel("dismiss")}
                        </Button>)

        return <div className='d-flex flex-row justify-content-center align-content-center'>
                    {components}
        </div>
    }

    renderCustomer()
    {
        let cliDetails = this.props.notification.payload;

        let components = [];
        if (cliDetails.customer != null)
        {
            const customer = cliDetails.customer;
            const rating = customer.profile ? customer.profile.rating : null;
            var allOrderCount = stringUtil.isStringNullOrEmpty(cliDetails.orderCount) ? 0 : cliDetails.orderCount;

            components.push(<tr style={{borderBottom:'1px solid #D0D0D0'}}>
                                <td style={{width:'99%'}}>
                                    Customer Name
                                </td>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'end'}}>
                                    {customer.name}
                                </td>
                            </tr>)

            components.push(<tr style={{borderBottom:'1px solid #D0D0D0'}}>
                                <td style={{width:'99%'}}>
                                    Ranking
                                </td>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'end'}}>
                                    <Rating rating={rating}></Rating>
                                </td>
                            </tr>)

            components.push(<tr style={{borderBottom:'1px solid #D0D0D0'}}>
                                <td style={{width:'99%'}}>
                                    Customer Phone Number
                                </td>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'end'}}>
                                    {customer.phoneNumber}
                                </td>
                            </tr>)

            components.push(<tr>
                                <td style={{width:'99%'}}>
                                    Order Count
                                </td>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'end'}}>
                                    {allOrderCount}
                                </td>
                            </tr>)
        }
        else
        {
            components.push(<tr style={{borderBottom:'1px solid #D0D0D0'}}>
                                <td style={{width:'99%'}}>
                                    Customer Name
                                </td>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'end'}}>
                                    New Customer
                                </td>
                            </tr>)

            components.push(<tr>
                                <td style={{width:'99%'}}>
                                    Customer Phone Number
                                </td>
                                <td style={{width:'1%', whiteSpace:'nowrap', textAlign:'end'}}>
                                    {cliDetails.cliIncomingNumber}
                                </td>
                            </tr>)
        }

        return <table width="100%">
                    {components}
                </table>
        
    }

    
}

export default NotificationDetail